'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = require('moment');

var moment = _interopRequireWildcard(_moment);

var _index = require('./index');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppBootstrap = function () {
    function AppBootstrap() {
        _classCallCheck(this, AppBootstrap);
    }

    _createClass(AppBootstrap, null, [{
        key: 'setup',
        value: function setup(client, packag, envs, storage, callback) {

            // Validate parans
            if (!client || ['web', 'mobile', 'admin'].indexOf(client) < 0) throw 'Unrecognized or undefined client: ' + client;
            // @todo Validate envs
            // @todo Validate packag
            // @todo Validate storage
            if (!callback || !callback.onMinVersionNotSatifies || !callback.onNewVersion || !callback.onUncaughtError) throw 'You must pass callback parameter to AppBootstrap.setup, with onMinVersionNotSatifies, onNewVersion and onUncaughtError methods.';
            AppBootstrap.callbacks = callback;

            // 1 - Decide env
            var nodeEnv = process.env.NODE_ENV;
            var version = packag.version;
            var firebase = void 0;
            var buildTime = void 0;
            var buildTimeString = void 0;
            if (client !== 'mobile') {
                firebase = process.env.FIREBASE && process.env.FIREBASE === true;
                buildTime = new Date(process.env.BUILD_TIME);
                buildTimeString = buildTime.toDateString() + ' ' + buildTime.toTimeString();
                console.log('CLIENT:' + client + ' - ENV:' + nodeEnv + ' - VERSION:' + version + ' - RELEASE DATE:' + process.env.APP_RELEASE + ' - BUILD_TIME:' + buildTimeString + ' - FIREBASE:' + firebase);
            } else if (__DEV__ !== undefined) {
                console.log('MOBILE CLIENT:' + client + ' - ENV:' + nodeEnv + ' - VERSION:' + version);
            }

            // console.log(envs);
            var config = void 0;
            if (nodeEnv === 'development' && firebase) {
                config = envs['development_firebase'];
                console.log('> firebase development <');
            } else {
                config = envs[nodeEnv];
            }

            console.log('Loaded config', config);
            if (config === undefined) {
                throw new Error('No config for NODE_ENV "' + nodeEnv + '"');
            }
            AppBootstrap.config = config;

            // 2 - Rollbar / bugsnag
            if (config.rollbarToken && client !== 'mobile') {
                _index.Rollbar.setup(config.rollbarToken, client + '_' + nodeEnv, process.env.APP_VERSION);
            } else if (client === 'mobile') {
                // Config of rollbar for native
                console.log('AppBootstrap is not configuring the Rollbar, please check if other source is configuring it.');
            } else if (nodeEnv === 'development') {
                console.warn('Rollbar not set on dev. It\'s ok.');
            } else {
                throw new Error('You must have Rollbar or bugsnag on your app.');
            }

            // 3 - Http
            _index.Http.setBaseURL(config.baseUrl);
            _index.Http.setup(packag.version, client, nodeEnv, 'application/json');
            _index.HttpErrorHandler.setup(callback);

            // 4 -  Moment
            moment.updateLocale('pt-br', require('moment/locale/pt-br'));

            // 5 - Version Check
            _index.VersionCheck.setCurrentVersion(client, version);
            _index.VersionCheck.onMinVersionNotSatifies(_index.Http, callback.onMinVersionNotSatifies);
            _index.VersionCheck.onNewVersion(storage).then(callback.onNewVersion);

            // // 6 - Capture errors onUncaught in AmActions
            // AMActions.onUncaughtError((e) => {
            //     if (e.message === 'Network request failed') {
            //         console.log('Network request failed, maybe you are offline');
            //     } else {
            //         console.error(e);
            //     }
            // });

            // 7 - Mobile fixes
            if (client === 'mobile') {
                if (nodeEnv === 'production') {
                    // Remove logs on PROD (performance)
                    console.log = function () {};
                    console.info = function () {};
                    console.warn = function () {};
                    console.error = function () {};
                    console.debug = function () {};
                }

                console.disableYellowBox = true;
            }

            // 8 -

            return true;
        }
    }, {
        key: 'onUncaughtError',
        value: function onUncaughtError() {
            return AppBootstrap.callbacks.onUncaughtError;
        }
    }, {
        key: 'onMinVersionNotSatifies',
        value: function onMinVersionNotSatifies() {
            return AppBootstrap.callbacks.onMinVersionNotSatifies;
        }
    }, {
        key: 'onNewVersion',
        value: function onNewVersion() {
            return AppBootstrap.callbacks.onNewVersion;
        }
    }, {
        key: 'getConfig',
        value: function getConfig() {
            return AppBootstrap.config;
        }
    }]);

    return AppBootstrap;
}();

AppBootstrap.callbacks = {};
AppBootstrap.config = null;

exports.default = AppBootstrap;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@app-masters/js-lib/dist/appBootstrap.js
// module id = 891
// module chunks = 0